import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { nextTick as e } from "../nextTick.js";
import s from "./RemoteClient.js";
import { MessageType as r, receiveMessage as t } from "./utils.js";

var n = function n() {
  var _this = this;

  _classCallCheck(this, n);

  var e = document.createDocumentFragment();
  ["addEventListener", "dispatchEvent", "removeEventListener"].forEach(function (s) {
    _this[s] = function () {
      return e[s].apply(e, arguments);
    };
  });
};

var a = /*#__PURE__*/function () {
  function a() {
    _classCallCheck(this, a);

    this._dispatcher = new n(), this._workerPostMessage({
      type: r.HANDSHAKE
    });
  }

  _createClass(a, [{
    key: "terminate",
    value: function terminate() {}
  }, {
    key: "onmessage",
    get: function get() {
      return this._onmessageHandler;
    },
    set: function set(e) {
      this._onmessageHandler && this.removeEventListener("message", this._onmessageHandler), this._onmessageHandler = e, e && this.addEventListener("message", e);
    }
  }, {
    key: "onmessageerror",
    get: function get() {
      return this._onmessageerrorHandler;
    },
    set: function set(e) {
      this._onmessageerrorHandler && this.removeEventListener("messageerror", this._onmessageerrorHandler), this._onmessageerrorHandler = e, e && this.addEventListener("messageerror", e);
    }
  }, {
    key: "onerror",
    get: function get() {
      return this._onerrorHandler;
    },
    set: function set(e) {
      this._onerrorHandler && this.removeEventListener("error", this._onerrorHandler), this._onerrorHandler = e, e && this.addEventListener("error", e);
    }
  }, {
    key: "postMessage",
    value: function postMessage(s) {
      var _this2 = this;

      e(function () {
        _this2._workerMessageHandler(new MessageEvent("message", {
          data: s
        }));
      });
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(e) {
      return this._dispatcher.dispatchEvent(e);
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(e, s, r) {
      this._dispatcher.addEventListener(e, s, r);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(e, s, r) {
      this._dispatcher.removeEventListener(e, s, r);
    }
  }, {
    key: "_workerPostMessage",
    value: function _workerPostMessage(s) {
      var _this3 = this;

      e(function () {
        _this3.dispatchEvent(new MessageEvent("message", {
          data: s
        }));
      });
    }
  }, {
    key: "_workerMessageHandler",
    value: function () {
      var _workerMessageHandler2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        var n, _e, _t, _a2, o;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                n = t(e);

                if (!(n && n.type === r.OPEN)) {
                  _context.next = 13;
                  break;
                }

                _e = n.modulePath, _t = n.jobId;
                _context.next = 5;
                return s.loadWorker(_e);

              case 5:
                _a2 = _context.sent;
                _context.t0 = _a2;

                if (_context.t0) {
                  _context.next = 11;
                  break;
                }

                _context.next = 10;
                return import(
                /* @vite-ignore */

                /* webpackIgnore: true */
                _e);

              case 10:
                _a2 = _context.sent;

              case 11:
                o = s.connect(_a2);

                this._workerPostMessage({
                  type: r.OPENED,
                  jobId: _t,
                  data: o
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _workerMessageHandler(_x) {
        return _workerMessageHandler2.apply(this, arguments);
      }

      return _workerMessageHandler;
    }()
  }]);

  return a;
}();

export { a as default };